import { render, staticRenderFns } from "./ErrorNotifications.vue?vue&type=template&id=13d236d6&scoped=true&"
import script from "./ErrorNotifications.vue?vue&type=script&lang=js&"
export * from "./ErrorNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotifications.vue?vue&type=style&index=0&id=13d236d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d236d6",
  null
  
)

export default component.exports